<template>
  <div class="main">
    <div class="profile">
      <img src="../assets/img/profile.jpg">
    </div>
    <div class="contact">
      <a href="mailto:cono.shota@gmail.com">Contact</a>
    </div>
    <div class="back">
      <router-link to="/">Back to home.</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  metaInfo: {
    title: 'About',
    titleTemplate: '%s | Shota KONO | Photography',
    meta: [{ vmid: 'description', name: 'description', content: 'about page | shotakono Photography website 写真家 河野翔大 オフィシャルウェブサイト' }]
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.main {
  margin-left: 2%;
}
.profile {
  margin-bottom: 6%;
}
.profile img {
  width: 90%;
}
.contact {
  margin-bottom: 1.8%;
}
.contact a {
  color: #ff0000;
}
.back a {
  color: #000000;
}
@media (min-width: 768px) {
  .main {
    margin-left: 10px;
  }
  .profile {
    margin-bottom: 42px;
  }
  .profile img {
    width: 500px;
  }
  .contact {
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue